import { render, staticRenderFns } from "./TaskPage.vue?vue&type=template&id=d1e5d8a4&scoped=true"
import script from "./TaskPage.vue?vue&type=script&lang=js"
export * from "./TaskPage.vue?vue&type=script&lang=js"
import style0 from "./TaskPage.vue?vue&type=style&index=0&id=d1e5d8a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1e5d8a4",
  null
  
)

export default component.exports